import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/Common/BreadCrumb/BreadCrumb";
import JobsHeader from "../../../../components/Common/JobsHeader/JobsHeader";
import FilterComponent from "../../../../components/Common/FilterJobs/FilterJobs";
import "./LAcceptedJobs.scss";
import AcceptedJobTable from "../../../../components/Table/Locum/AcceptedJobTable/AcceptedJobTabel";
import graphqlRequest from "../../../../requestMethod";
const LAcceptedjobs = () => {
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  let [tableData, setTableData] = useState([]);
  let [filterTable, setFilterTable] = useState([]);

  let [departmentList, setDepartmentList] = useState([]);
  let [departmentValue, setDepartmentValue] = useState("");

  let [professionalList, setProfessionalList] = useState([]);
  let [professionsValue, setProfessionValue] = useState("");

  let [globalInputSearch, SetGlobalInputSearch] = useState("");

  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  
  const [totalData, setTotalData] = useState([]) 
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  let [filterByProfession, setFilterByProfession] = useState("");
  let [filterByDepartment, setFilterByDepartment] = useState("");
  let [filterByStartDate, setFilterByStartDate] = useState("");
  let [filterByEndDate, setFilterByEndDate] = useState("");
  let [filterByBranch, setFilterByBranch] = useState("");
  let [hospitalBranchList, setHospitalBranchList] = useState([]);

  let [hospitalBranchData, setHospitalBranchData] = useState([]);
  const [hospitalBranch, setHospitalBranch] = useState("");
  const [hospitalBranchId, setHospitalBranchId] = useState("");
 
  function check(start, end, current) {
    if (current >= start && current < end) {
      return true;
    } else {
      return false;
    }
  }
  function filterAcceptedJobTable(query) {
    let { department, professionalType, start, end } = query;
    function search(elem) {
      let flag = {};
      if (!!department) {
        flag.department = elem?.job?.department === department;
      }
      if (!!professionalType) {
        flag.professional =
          elem?.professional?.professionalType.name === professionalType;
      }
      if (!!start && !!end) {
        flag.time = check(start, end, new Date(Number(elem?.job?.start)));
      }
      return Object.values(flag).every((test) => test == true);
    }
    let filterData = tableData.filter(search);

    setFilterTable(filterData);
  }
  function filterDepartment(data) {
    let onlyDep = Array.from(new Set(data.map((data) => data.job.department)));
    setDepartmentList(onlyDep);
  }
  function filterProfessional(data) {
    let onlyPro = Array.from(
      new Set(data.map((data) => data.professional?.professionalType?.name))
    );
    setProfessionalList(onlyPro);
  }
  function filterHospitalBranch(data) {
    // console.log("data", data)
    let onlyPro = Array.from(
      new Set(data.map((data) => data.job.hospitalName))
    );
    setHospitalBranchList(onlyPro);
  }

  function fetchHospitalDropdownData() {
    const query = `
    query{
      withAuth(token:"${token}"){
        listMiniJobBranches{
          id
          jobLocation {
            hospitalName
            branchName
          }
       }
       }
     }
  `;
    graphqlRequest(query).then((response) => {
      // console.log("response>>>>>", response);
      setHospitalBranchData(response.data.withAuth.listMiniJobBranches);
    });
  }
  // console.log("hospitalBranchData", hospitalBranchData);
  const hospitalBranchOptions = [];
  hospitalBranchData.map((ele) => {
    // console.log("ele", ele);
    let obj = {
      key: ele.id,
      value: ele.jobLocation.branchName,
    };

    hospitalBranchOptions.push(obj);
  });

  // console.log("hospitalBranchOptions", hospitalBranchOptions);

  const handleBranchFilterChange = (e) => {
    const selectedBranch = e.target.value;
    let selectedBranchObjectID;

    hospitalBranchOptions.forEach((branch) => {
      // console.log("branch", branch);
      if (branch.value === selectedBranch) {
        // selectedBranchObjectID = branch.key;
        selectedBranchObjectID = branch.value;
      }
    });

    setHospitalBranch(selectedBranch);
    setHospitalBranchId(selectedBranchObjectID)

    // dispatch(filterRole(selectedRoleObjectID));
  };

  let fetchAcceptedJob = () => {
    setLoading(true);
    const query = `
    query {
      withAuth(token: "${token}") {
        listMiniJobApplications(type:UPCOMING, limit: ${limit}, offset: ${currentPage},search: "${keyword}", filterByProfession: "${filterByProfession}", department: "${filterByDepartment}", startDate: "${filterByStartDate}", endDate:"${filterByEndDate}", filterByHospitalBranch: "${hospitalBranchId}"){
          id
          pocDetails{
            contactPerson
            email
            phone
          }
          professional{
           id
            status
            avatar{
            url
            }
            professionalRegistration{
              nameAsPerDocument
              number
              registrationDate{
                year
                month
                date
              }
              registrationState
              instituteName
              expiryDate{
                year
                month
                date
              }
            }
            profile{
              education{
                name
                year
                course
              }
              jobHistory{
                hospital
                department
                specialisation

                start
                end
              }
            }
             specialization {
            name
            id
          }
              departments{
              id
              name
            }
            name {
            full
          }
              professionalType {
            name
          }
               numExperience {
            name
          }
              qualification {
            name
          }
            professionalResume{
              resumeStatus
              manualResumeUrl
              AIResumeUrl
            }
            documents{
              docType{
                name
              }
              files{
                url
              }
            }
          }
            job {
            id
            code
            department
            specialization
            start
            end
          jobDescription
          applications
          hospitalName
          contactDetail{
                contactPerson
                email
                phone
            }
        }
        }
      }
  }
    `;

    graphqlRequest(query).then((response) => {
      // console.log("accepted response>>", response);
      setTotalData(response?.data?.totalApplicationCount || 0);
      setTableData(response.data.withAuth.listMiniJobApplications);
      setLoading(false);
      setFilterTable(response.data.withAuth.listMiniJobApplications);
      filterDepartment(response.data.withAuth.listMiniJobApplications);
      filterProfessional(response.data.withAuth.listMiniJobApplications);
      filterHospitalBranch(response.data.withAuth.listMiniJobApplications);
    });
  };
  let removeOpenJob = (id) => {
    const query = `
      mutation{
        mutationWithAuth(token:"${token}"){
          update{
            cancelMiniJobApplication(application:"${id}")
          }
        }
      }
    `;

    graphqlRequest(query).then((response) => {
      fetchAcceptedJob();
    });
  };
  function filterGlobalSearch() {
    let data = tableData.filter((data) => {
      if (
        data.job.code.toUpperCase().includes(globalInputSearch.toUpperCase()) ||
        data.job.specialization
          .toUpperCase()
          .includes(globalInputSearch.toUpperCase()) ||
        data.professional.name.full
          .toUpperCase()
          .includes(globalInputSearch.toUpperCase())
      ) {
        return data;
      }
    });
    setFilterTable(data);
  }
  useEffect(() => {
    fetchAcceptedJob();
  }, [currentPage,limit,keyword,filterByProfession,filterByDepartment,filterByStartDate,filterByEndDate, filterByBranch,hospitalBranch,hospitalBranchId]);

  useEffect(() => {
    fetchHospitalDropdownData();
  }, []);

  useEffect(() => {
    let query = {};
    !!departmentValue && (query["department"] = departmentValue);

    !!professionsValue && (query["professionalType"] = professionsValue);
    // create this like query and passed in funcation as an object
    !!filterDate[0]?.startDate &&
      (query["start"] = new Date(filterDate[0]?.startDate));
    !!filterDate[0]?.endDate &&
      (query["end"] = new Date(filterDate[0]?.endDate));

    query?.end && query?.end?.setHours(23, 59, 59);

    filterAcceptedJobTable(query); // call that funcation, which filter the table data
  }, [departmentValue, professionsValue, filterDate]);

  useEffect(() => {
    filterGlobalSearch();
  }, [globalInputSearch]);
  

  return (
    <div className="acceptedjob-container">
    <div className="acceptedjob-wrapper">
      <JobsHeader title={"Accepted Jobs"} />
      <BreadCrumb action={"Jobs"} title={"Accepted Jobs"} />
      <FilterComponent
        fetchAllData={fetchAcceptedJob}
        title={"ACCEPTEDJOOBS"}
        professional={"TYPE OF ACCEPTED JOBS"}
        departmentList={departmentList}
        professionalList={professionalList}
        SetGlobalInputSearch={SetGlobalInputSearch}
        setProfessionValue={setProfessionValue}
        setDepartmentValue={setDepartmentValue}
        globalInputSearch={globalInputSearch}
        setFilterTable={setFilterTable}
        tableData={tableData}
        setFilterDate={setFilterDate}
        filterDate={filterDate}
        departmentValue={departmentValue}
        professionsValue={professionsValue}
        keyword={keyword}
        setKeyword={setKeyword}
        filterByProfession={filterByProfession}
        setFilterByProfession={setFilterByProfession}
        filterByDepartment={filterByDepartment}
        setFilterByDepartment={setFilterByDepartment}
        filterByStartDate={filterByStartDate} 
        setFilterByStartDate={setFilterByStartDate}
        filterByEndDate={filterByEndDate} 
        setFilterByEndDate={setFilterByEndDate}
        filterByBranch={filterByBranch}
        setFilterByBranch={setFilterByBranch}
        hospitalBranchList={hospitalBranchList}
        hospitalBranch={hospitalBranch}
          handleBranchFilterChange={handleBranchFilterChange}
          hospitalBranchOptions={hospitalBranchOptions}
          setHospitalBranch={setHospitalBranch}
          setHospitalBranchId={setHospitalBranchId}
      />
      <AcceptedJobTable
        loading={loading}
        filterTable={filterTable}
        totalData={totalData}
        currentPage={currentPage}
        limit={limit}
        setCurrentPage={setCurrentPage}
        setLimit={setLimit}
        removeOpenJob={removeOpenJob}
      />
    </div>
    </div>
  );
};

export default LAcceptedjobs;
